import { useQuery, keepPreviousData } from "@tanstack/react-query";

import {
  evalSelector,
  type SelectorEvalRequest,
  type SelectorEvalResponse,
} from "../api/filter";

export function useSelectorEval(body: SelectorEvalRequest) {
  return useQuery<SelectorEvalResponse>({
    queryKey: ["selector", "eval", body],
    queryFn: () => evalSelector(body),
    staleTime: 30 * 1000,
    placeholderData: keepPreviousData,
  });
}
